var _a, _b, _c, _d, _e, _f, _g;
import { __decorate, __metadata } from "tslib";
import angular from 'angular';
import { v4 as uuid } from 'uuid';
import { Component } from 'decorators';
import { ActionsListAddAction, ActionsListDeleteItem, ActionsListOpenDetail, ActionsListUpdateAndSave } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/tabs/actions/components/actionsList/actionsList.dispatcher';
import { UndoRedoService } from 'modules/application/misc/UndoRedoService';
import { GLOBAL_ACTIONS } from '../../../../BuilderController';
import { BuilderFeatures } from '../../../../BuilderFeatures';
import { ActionTabIAction } from '../../../../historyActions';
import { MoveActionIAction } from '../../../../historyActions/MoveActionIAction';
import { BuilderSegmentService } from '../../../../services/BuilderSegmentService';
import { BuilderStore } from '../../../../store/BuilderStore';
import { BlipToastService } from 'modules/shared/BlipToastService';
import { ToastType } from 'modules/application/misc/ToastService';
// CSS
import './ActionList.scss';
// Views
import template from './ActionsListView.html';
import { FunctionService } from '../../../../services/FunctionService';
import { ActionService } from '../../../../services/ActionService';
const builderStore = BuilderStore.getInstance();
const ACTIONS_LIMIT = 15;
const REDIRECT_SERVICE_ACTION = 'Redirect';
const PROCESS_CONTENT_ASSISTANT_ACTION = 'ProcessContentAssistant';
var ActionType;
(function (ActionType) {
    ActionType["enteringCustomActions"] = "enteringCustomActions";
    ActionType["leavingCustomActions"] = "leavingCustomActions";
})(ActionType || (ActionType = {}));
let ActionsListComponent = class ActionsListComponent {
    static $inject = ['BlipToastService', 'clipboard', 'UndoRedoService', 'PipelineBuilderSegmentService', '$translate', 'FunctionService', 'ActionService'];
    constructor(BlipToastService, clipboard, UndoRedoService, PipelineBuilderSegmentService, $translate, FunctionService, ActionService) {
        'ngInject';
        this.BlipToastService = BlipToastService;
        this.clipboard = clipboard;
        this.UndoRedoService = UndoRedoService;
        this.PipelineBuilderSegmentService = PipelineBuilderSegmentService;
        this.$translate = $translate;
        this.FunctionService = FunctionService;
        this.ActionService = ActionService;
        this.actions = [];
        this.isActionsExceeded = false;
        this.nameOfTheBlock = '';
        this.isMovingEnteringLeavingActionEnabled = false;
        this.selectedActions = [];
        this.selectAction = (event) => {
            const state = this;
            const actionSelected = state.actions.filter(act => act.$id === event.target.id)[0];
            if (actionSelected !== undefined) {
                const actions = state.selectedActions.filter(act => act.$id === actionSelected.$id);
                if (actions.length === 0) {
                    state.selectedActions.push(actionSelected);
                }
                else {
                    state.selectedActions = state.selectedActions.filter(act => act.$id !== actionSelected.$id);
                }
                this.trackActionSelected();
            }
        };
        this.copySelectedActions = async () => {
            try {
                const jsonStringAction = JSON.stringify(this.selectedActions);
                this.clipboard.copyText(jsonStringAction);
                const copySelectedActionsSuccess = await this.$translate('builder-tabs-actions.copyActionsSuccess');
                this.BlipToastService.show(ToastType.Success, {
                    msg: copySelectedActionsSuccess,
                    duration: 3000,
                });
                this.trackCopyAllActions();
            }
            catch (ex) {
                const copySelectedActionsError = await this.$translate('builder-tabs-actions.copySelectedActionsError');
                this.BlipToastService.show(ToastType.Danger, {
                    msg: copySelectedActionsError,
                    duration: 3000,
                });
            }
        };
        this.copyAction = async (action) => {
            try {
                const jsonStringAction = JSON.stringify(action);
                this.clipboard.copyText(jsonStringAction);
                const copySelectedActionsSuccess = await this.$translate('builder-tabs-actions.copyActionSuccess');
                this.BlipToastService.show(ToastType.Success, {
                    msg: copySelectedActionsSuccess,
                    duration: 3000,
                });
                this.trackCopyAction();
            }
            catch (ex) {
                const copyActionErrorMessage = await this.$translate('builder-tabs-actions.copyActionError');
                this.BlipToastService.show(ToastType.Danger, {
                    msg: copyActionErrorMessage,
                    duration: 3000,
                });
            }
        };
        this.pasteSelectedActions = async () => {
            if (!navigator.clipboard.readText) {
                return;
            }
            try {
                const copiedActions = await navigator.clipboard.readText();
                const actions = JSON.parse(copiedActions);
                const totalActions = this.actions.length + actions.length;
                if (totalActions > ACTIONS_LIMIT) {
                    const exceededCopyActionsMessage = await this.$translate('builder-tabs-actions.exceededCopyActions');
                    this.BlipToastService.show(ToastType.Warning, {
                        msg: exceededCopyActionsMessage,
                        duration: 3000,
                    });
                    return;
                }
                this.addActions(actions);
            }
            catch (ex) {
                const pasteSelectedActionsError = await this.$translate('builder-tabs-actions.pasteActionError');
                this.BlipToastService.show(ToastType.Danger, {
                    msg: pasteSelectedActionsError,
                    duration: 3000,
                });
            }
        };
        this.deleteSelectedActions = async () => {
            try {
                if (this.selectedActions) {
                    const sources = [];
                    this.selectedActions.forEach(action => {
                        if (action.type === 'ExecuteBlipFunction' && action.settings?.source) {
                            sources.push(action.settings.source);
                        }
                    });
                    const application = await this.ActionService.getApplication();
                    for (const source of sources) {
                        await this.FunctionService.deleteFunctionWithApplication(application?.shortName, source);
                    }
                    const selectedIds = new Set(this.selectedActions.map(action => action.$id));
                    this.actions = this.actions.filter(action => !selectedIds.has(action.$id));
                    this.selectedActions.forEach(action => {
                        this.onDeleteAction(undefined, action);
                    });
                    this.selectedActions = [];
                    const deleteSelectedActionsSuccessMessage = await this.$translate('builder-tabs-actions.deleteActionsSuccess');
                    this.BlipToastService.show(ToastType.Success, {
                        msg: deleteSelectedActionsSuccessMessage,
                        duration: 3000,
                    });
                    this.trackDeleteAllActionsSelected();
                }
            }
            catch (ex) {
                const deleteSelectedActionsErrorMessage = await this.$translate('builder-tabs-actions.deleteSelectedActionsError');
                this.BlipToastService.show(ToastType.Danger, {
                    msg: deleteSelectedActionsErrorMessage,
                    duration: 3000,
                });
            }
        };
        this.selectAllActions = async (event) => {
            this.selectedActions = event.detail.checked === false ? [] : this.actions;
            this.trackAllSelectedActions();
        };
        this.isSelectedAction = ($action) => this.selectedActions?.some(act => act.$id === $action.$id) ?? false;
        this.deleteAction = async ($event, deletedAction) => {
            if (deletedAction.type === 'ExecuteBlipFunction') {
                const source = deletedAction.settings?.source;
                const application = await this.ActionService.getApplication();
                if (source) {
                    await this.FunctionService.deleteFunctionWithApplication(application?.shortName, source);
                }
            }
            try {
                this.onDeleteAction($event, deletedAction);
                const deleteSelectedActionsSuccess = await this.$translate('builder-tabs-actions.deleteActionSuccess');
                this.BlipToastService.show(ToastType.Success, {
                    msg: deleteSelectedActionsSuccess,
                    duration: 3000,
                });
            }
            catch (ex) {
                const deleteActionErrorMessage = await this.$translate('builder-tabs-actions.deleteActionError');
                this.BlipToastService.show(ToastType.Danger, {
                    msg: deleteActionErrorMessage,
                    duration: 3000,
                });
            }
        };
        this.isAllActionsSelected = () => this.actions?.length > 0 && this.selectedActions.length === this.actions.length ? true : false;
        this.addActions = async (actions) => {
            let shouldShowSuccessMessage = true;
            const actionsToProcess = Array.isArray(actions) ? actions : [actions];
            if (this.isSubflowApplication === true) {
                shouldShowSuccessMessage = await this.validateActionsForSubflow(actionsToProcess);
            }
            try {
                if (actions !== undefined) {
                    const isAllActions = actions.length > 1 ? true : false;
                    actionsToProcess.forEach(action => {
                        action.$id = uuid();
                        this.actions.concat(action);
                        this.$dispatch(new ActionsListAddAction({ action }));
                    });
                    if (shouldShowSuccessMessage) {
                        const successMessageKey = isAllActions ? 'pasteActionsSuccess' : 'pasteActionSuccess';
                        const pasteSuccessMessage = await this.$translate(`builder-tabs-actions.${successMessageKey}`);
                        this.BlipToastService.show(ToastType.Success, {
                            msg: pasteSuccessMessage,
                            duration: 3000,
                        });
                    }
                    isAllActions ? this.trackPasteAllActionsSelected() : this.trackPasteSelectedAction();
                }
            }
            catch (ex) {
                const pasteActionErrorMessage = await this.$translate('builder-tabs-actions.pasteActionError');
                this.BlipToastService.show(ToastType.Danger, {
                    msg: pasteActionErrorMessage,
                    duration: 3000,
                });
            }
        };
        this.pasteActionsDisabled = () => this.actions?.length >= 15 ? true : false;
    }
    $onInit() {
        this.getNameOfGlobalBlock();
        this.initializeSort();
    }
    isSubflowDefaultAction(action) {
        return !action.subflowDefaultAction;
    }
    async getNameOfGlobalBlock() {
        this.nameOfTheBlock = await this.$translate('builder-configurations.globalActions.title');
    }
    async initializeSort() {
        this.isMovingEnteringLeavingActionEnabled = await BuilderFeatures.movingEnteringLeavingActionEnabled();
        this.ngSortableOptions = {
            animation: 0,
            scroll: true,
            handle: '.anchor',
            group: this.isMovingEnteringLeavingActionEnabled ? 'sorting' : undefined,
            onSort: async (e) => {
                if (this.isMovingEnteringLeavingActionEnabled) {
                    return;
                }
                const currentState = angular.copy(this.state);
                const segmentPayload = {
                    blockId: currentState.id === GLOBAL_ACTIONS ? this.nameOfTheBlock : currentState.id,
                    blockName: currentState.$title,
                    actionType: 'move',
                };
                const actionIAction = new ActionTabIAction({
                    data: {
                        after: undefined, before: undefined,
                        state: {
                            id: currentState.id === GLOBAL_ACTIONS ? this.nameOfTheBlock : currentState.id,
                            $title: [currentState.$title, currentState.id].includes(GLOBAL_ACTIONS) ? this.nameOfTheBlock : currentState.$title || currentState.id, //covering cases where GlobalActions or actions should be accepted
                        },
                    },
                    execute: async () => {
                        this.type === ActionType.enteringCustomActions
                            ? this.swapEnteringActionsPosition(e?.oldIndex, e?.newIndex)
                            : this.swapLeavingActionsPosition(e?.oldIndex, e?.newIndex);
                        this.trackBlockActionRedo(true, segmentPayload);
                        await this.onUpdateAndSave();
                    },
                    undo: async () => {
                        this.type === ActionType.enteringCustomActions
                            ? this.swapEnteringActionsPosition(e?.newIndex, e?.oldIndex)
                            : this.swapLeavingActionsPosition(e?.newIndex, e?.oldIndex);
                        this.trackBlockActionUndo(true, segmentPayload);
                        await this.onUpdateAndSave();
                    },
                });
                if (await BuilderFeatures.builderUndoRedoContentEnabled()) {
                    this.UndoRedoService.add(actionIAction);
                }
                this.onUpdateAndSave();
            },
            onStart: async (e) => {
                this.oldState = angular.copy(this.state);
            },
            onEnd: async (e) => {
                if (!this.isMovingEnteringLeavingActionEnabled) {
                    return;
                }
                const currentState = angular.copy(this.state);
                const segmentPayload = {
                    blockId: currentState.id === GLOBAL_ACTIONS ? this.nameOfTheBlock : currentState.id,
                    blockName: currentState.$title,
                    actionType: 'ordering',
                };
                const moveIAction = new MoveActionIAction({
                    data: {
                        after: currentState, before: this.oldState,
                        state: {
                            id: currentState.id === GLOBAL_ACTIONS ? this.nameOfTheBlock : currentState.id,
                            $title: [currentState.$title, currentState.id].includes(GLOBAL_ACTIONS) ? this.nameOfTheBlock : currentState.$title || currentState.id, //covering cases where GlobalActions or actions should be accepted
                        },
                    },
                    execute: async (data) => {
                        builderStore.setState({
                            ...data.after,
                        });
                        this.trackBlockActionUndo(true, segmentPayload);
                    },
                    undo: async (data) => {
                        builderStore.setState({
                            ...data.before,
                        });
                        this.trackBlockActionUndo(true, segmentPayload);
                    },
                });
                if (await BuilderFeatures.builderUndoRedoContentEnabled()) {
                    this.UndoRedoService.add(moveIAction);
                }
                this.onUpdateAndSave();
            },
        };
    }
    swapEnteringActionsPosition(firstActionIndex, secondActionIndex) {
        const isValidActionChange = this.cleanUnecessaryActions(this.state.$enteringCustomActions);
        const firstAction = this.state.$enteringCustomActions[firstActionIndex];
        const secondAction = this.state.$enteringCustomActions[secondActionIndex];
        if (!isValidActionChange || !firstAction || !secondAction) {
            return;
        }
        this.state.$enteringCustomActions[firstActionIndex] = secondAction;
        this.state.$enteringCustomActions[secondActionIndex] = firstAction;
    }
    swapLeavingActionsPosition(firstActionIndex, secondActionIndex) {
        const isValidActionChange = this.cleanUnecessaryActions(this.state.$leavingCustomActions);
        const firstAction = this.state.$leavingCustomActions[firstActionIndex];
        const secondAction = this.state.$leavingCustomActions[secondActionIndex];
        if (!isValidActionChange) {
            return;
        }
        this.state.$leavingCustomActions[firstActionIndex] = secondAction;
        this.state.$leavingCustomActions[secondActionIndex] = firstAction;
    }
    cleanUnecessaryActions(value) {
        let isValidActionChange = true;
        if (!value) {
            return;
        }
        value = value.filter(item => {
            if (!item) {
                isValidActionChange = false;
            }
            return item !== undefined;
        });
        return isValidActionChange;
    }
    $dispatch($action) {
        if (this.onAction) {
            this.onAction({ $action });
        }
        else {
            throw new Error('onAction is not implemented');
        }
    }
    onUpdateAndSave() {
        const action = new ActionsListUpdateAndSave();
        this.$dispatch(action);
    }
    onDeleteAction($event, deletedAction) {
        if ($event) {
            $event.stopPropagation();
        }
        const action = new ActionsListDeleteItem({
            action: deletedAction,
        });
        this.$dispatch(action);
    }
    onOpenActionDetail(actionViewModel) {
        const action = new ActionsListOpenDetail({
            action: actionViewModel,
        });
        this.$dispatch(action);
    }
    async validateActionsForSubflow(actions) {
        const blockedActionTypesTitle = new Set();
        const blockedActions = actions.filter(act => act.type == REDIRECT_SERVICE_ACTION || act.type == PROCESS_CONTENT_ASSISTANT_ACTION);
        blockedActions.forEach(act => {
            if (act.type == REDIRECT_SERVICE_ACTION || act.type == PROCESS_CONTENT_ASSISTANT_ACTION) {
                blockedActionTypesTitle.add(act.type);
            }
        });
        if (blockedActions.length > 0) {
            return await this.showBlockedActionsError(blockedActions, actions, blockedActionTypesTitle);
        }
        return true;
    }
    async showBlockedActionsError(blockedActions, actions, blockedActionTypesTitle) {
        let blockedActionsMessage;
        for (let i = 0; i < blockedActions.length; i++) {
            const index = actions.indexOf(blockedActions[i]);
            if (index !== -1) {
                actions.splice(index, 1);
            }
        }
        const blockedActionsType = Array.from(blockedActionTypesTitle);
        const formattedTitles = blockedActionsType.map(action => action.charAt(0).toLowerCase() + action.slice(1));
        const titlesTranslate = await Promise.all(formattedTitles.map(async (title) => `"${await this.$translate(`builder-tabs-actions.${title}.title`)}"`));
        blockedActionsMessage = await this.$translate('builder-tabs-actions.blockedActions', { actionsTitles: `${titlesTranslate.join(', ')}` });
        this.BlipToastService.show(ToastType.Warning, {
            msg: blockedActionsMessage,
            duration: 3000,
        });
        return false;
    }
    // Segment Methods
    trackBlockActionUndo(success, segmentPayload) {
        this.PipelineBuilderSegmentService.trackBlockActionUndo(segmentPayload, success);
    }
    trackBlockActionRedo(success, segmentPayload) {
        this.PipelineBuilderSegmentService.trackBlockActionRedo(segmentPayload, success);
    }
    trackActionSelected() {
        this.PipelineBuilderSegmentService.trackSelectedActionCheckbox();
    }
    trackAllSelectedActions() {
        this.PipelineBuilderSegmentService.trackAllSelectedActionsCheckboxes();
    }
    trackCopyAction() {
        this.PipelineBuilderSegmentService.trackCopySelectedAction();
    }
    trackCopyAllActions() {
        this.PipelineBuilderSegmentService.trackCopyAllActions();
    }
    trackPasteSelectedAction() {
        this.PipelineBuilderSegmentService.trackPasteAction();
    }
    trackPasteAllActionsSelected() {
        this.PipelineBuilderSegmentService.trackPasteAllActionsSelected();
    }
    trackDeleteAllActionsSelected() {
        this.PipelineBuilderSegmentService.trackDeleteAllActionsSelected();
    }
};
ActionsListComponent.$inject = ['BlipToastService', 'clipboard', 'UndoRedoService', 'PipelineBuilderSegmentService', '$translate', 'FunctionService', 'ActionService'];
ActionsListComponent = __decorate([
    Component({
        template,
        bindings: {
            actions: '=',
            onAction: '&',
            onIsSelectedAction: '&',
            state: '=?',
            type: '@?',
            isSubflowApplication: '<?',
        },
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof BlipToastService !== "undefined" && BlipToastService) === "function" ? _a : Object, Object, typeof (_b = typeof UndoRedoService !== "undefined" && UndoRedoService) === "function" ? _b : Object, typeof (_c = typeof BuilderSegmentService !== "undefined" && BuilderSegmentService) === "function" ? _c : Object, typeof (_e = typeof angular !== "undefined" && (_d = angular.translate) !== void 0 && _d.ITranslateService) === "function" ? _e : Object, typeof (_f = typeof FunctionService !== "undefined" && FunctionService) === "function" ? _f : Object, typeof (_g = typeof ActionService !== "undefined" && ActionService) === "function" ? _g : Object])
], ActionsListComponent);
export { ActionsListComponent };
